import React from 'react';

import { Link } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';

import HamburgerMenu from './HamburgerMenu';
import * as style from './MobileNav.module.css';

const MobileNav = ({ buttonTitle, link, openInNewTab }) => {
  return (
    <div className={style.mobileNav}>
      <div className={style.navbar}>
        <div className={style.mobileHeader}>
          <div className={style.logoContainer}>
            <Link to="/">
              <StaticImage
                className={style.logo}
                src="../../images/gradientLogo.png"
                alt="Logo"
              />
            </Link>
          </div>
          <HamburgerMenu
            link={link}
            buttonTitle={buttonTitle}
            openInNewTab={openInNewTab}
          />
        </div>
      </div>
    </div>
  );
};

export default MobileNav;
